import { axios } from 'utils/axios';

// SafetyGuru video endpoints
const getVideos = (params = {}) => {
    return axios.get('/safetyguru/videos', { params });
};

const getVideoById = (id) => {
    return axios.get(`/safetyguru/videos/${id}`);
};

const getCategories = () => {
    return axios.get('/safetyguru/categories');
};

export {
    getVideos,
    getVideoById,
    getCategories,
};
